module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"today_text":"heute"},"en":{"today_text":"today"}}')
  delete Component.options._Ctor
}
